import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhyAvega } from './components/WhyAvega';
import { AppTour } from './components/AppTour';
import { PlayModes } from './components/PlayModes';
import { Ecosystem } from './components/Ecosystem';
import { PrivacyCenter } from './components/PrivacyCenter';
import { FaqSection } from './components/FaqSection';
import { DownloadCta } from './components/DownloadCta';
import { Footer } from './components/Footer';
import { useSmoothScroll } from './hooks/useSmoothScroll';
export function App() {
  useSmoothScroll();
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="31cjk5p91r2w3">
      <div className="min-h-screen w-full bg-canvas font-sans text-ink antialiased" data-id="element-1" data-mp="2wiyy8vkq9zd9">
        <Navbar data-id="element-2" data-mp="28tw9l3rof699" />
        <main data-id="element-3" data-mp="28te37ebavbnm">
          <Hero data-id="element-4" data-mp="28suw6sn6u7od" />
          <WhyAvega data-id="element-5" data-mp="28sbbx5a2f776" />
          <AppTour data-id="element-6" data-mp="23vci6nubd29i" />
          <PlayModes data-id="element-7" data-mp="23vul23bheeqe" />
          <Ecosystem data-id="element-8" data-mp="23ujk0b9f7l2z" />
          <PrivacyCenter data-id="element-9" data-mp="23v2tr4ox335x" />
          <FaqSection data-id="element-10" data-mp="3ijxnsm94vshs" />
          <DownloadCta data-id="element-11" data-mp="3ikh5q2ysagvt" />
        </main>
        <Footer data-id="element-12" data-mp="3ijftvw9y1qd1" />
      </div>
    </MotionConfig>;
}